import { useEffect } from 'react';

import { companyService, useCompany } from '@webtrader/core/services/company';
import storage, { EStorageKey } from '@webtrader/core/storage';

interface IUseCompanySettingsProps {
  mobileapp?: boolean;
  backoffice?: boolean;
}

/**
 * !!!! DO NOT USE FOR MOBILE APP, only for web/mobile web !!!!
 * @param props
 */
export const useCompanySettings = (props?: IUseCompanySettingsProps) => {
  const { mobileapp, backoffice } = props || {};
  const { company, loading, access, contact } = useCompany();

  useEffect(() => {
    if (mobileapp) {
      return;
    }

    if (!company) {
      companyService.init(backoffice);
    }
  }, [company, mobileapp, backoffice]);

  useEffect(() => {
    if (mobileapp) {
      return;
    }

    let link = document.querySelector("link[rel~='icon']");

    const faviconPath = company?.faviconPath;
    const favicon = faviconPath ? `/${faviconPath}` : '';

    if (!loading) {
      if (!link) {
        link = document.createElement('link');
      }
      const currentHref = link.getAttribute('href');
      if (currentHref !== favicon) {
        link.setAttribute('rel', 'icon');
        link.setAttribute('href', favicon);

        if (!link.parentNode) {
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      }
    }

    document.title = 'WebTrader Platform';

    if (company?.name) {
      const title = `${company.name} - WebTrader Platform`;

      storage.setItem(EStorageKey.TITLE, title);

      document.title = title;
    }
  }, [company, loading, mobileapp]);

  return {
    company,
    contact,
    loading,
    access
  };
};
